<template>
<div class="chapter">
<div class="inner_page">
<p class="imagefp"><a id="page_5"></a><a id="contents"><img alt="contents" src="images/f0005-01.jpg" width="100%"/></a></p><a id="contents">
</a><p class="tocfm"><a id="contents"></a><a class="nounder" href="#/xhtml/foreword#foreword"><strong>FOREWORD</strong></a></p>
<p class="tocfm"><a class="nounder" href="#/xhtml/intro#intro"><strong>INTRODUCTION</strong></a></p>
<p class="tocfm1"><a class="nounder" href="#/xhtml/ingredi#ingredi"><strong>INGREDIENTS</strong></a></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch01#ch01" title="Link target outside of Sample"><strong>CHAPTER 1:</strong> Nibbly Foods: For Parties or Just for Fun</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample"><strong>CHAPTER 2:</strong> Sauces</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample"><strong>CHAPTER 3:</strong> Baked Goods, “Cereals,” and Other Grainlike Things</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample"><strong>CHAPTER 4:</strong> Eggs</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample"><strong>CHAPTER 5:</strong> Side Salads and Dressings</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample"><strong>CHAPTER 6:</strong> Vegetables and Other Hot Side Dishes</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample"><strong>CHAPTER 7:</strong> Main-Dish Salads</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample"><strong>CHAPTER 8:</strong> Beef</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample"><strong>CHAPTER 9:</strong> Poultry</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample"><strong>CHAPTER 10:</strong> Pork and Lamb</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample"><strong>CHAPTER 11:</strong> Seafood</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample"><strong>CHAPTER 12:</strong> Soups</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch13#ch13" title="Link target outside of Sample"><strong>CHAPTER 13:</strong> Sippables</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch14#ch14" title="Link target outside of Sample"><strong>CHAPTER 14:</strong> Sweets</span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/about#about" title="Link target outside of Sample"><strong>ABOUT THE AUTHOR</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/acknow#acknow" title="Link target outside of Sample"><strong>ACKNOWLEDGMENTS</strong></span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample"><strong>INDEX</strong></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?c7dab2e0